module.exports = __webpack_public_path__ + "static/media/img3.8110e9f8.jpg";